<template>
  <div class="row">
    <div class="col-12">
      <div class="sms-card">
        <b-form-group
          :label="`${this.$t('newAction.stepOne.labels.sms')}`"
          v-if="action.sms.config === 'link'"
          style="width: 100%;"
        >
          <b-input-group
            append="https://id-cx.co/8dígitos"
            class="mb-2 mr-sm-2 mb-sm-0"
          >
            <b-input
              id="message-link-id"
              :placeholder="`${this.$t(
                'newAction.stepOne.placeholderTextLink',
              )}`"
              v-model="action.sms.msgLink"
              style="box-shadow: none;"
              maxlength="130"
            ></b-input>
          </b-input-group>
          <p class="text-danger">{{ smsError }}</p>
        </b-form-group>
        <picture>
          <img
            src="@/assets/mobile.png"
            :alt="`${this.$t('newAction.stepOne.altCellPhone')}`"
            style="width: 250px;"
          />
          <div class="msgs-area">
            <figcaption class="ballon-text mb-3">
              <span v-if="action.sms.config === 'link'"
                >{{ action.sms.msgLink }} https://id-cx.co/8dígitos</span
              >
              <span v-if="action.sms.config === 'body'">
                {{ action.question }}
              </span>
              <div class="arrow" />
            </figcaption>
            <figcaption
              class="ballon-promoter-answer mb-3"
              v-if="
                switchReply.promoters === true &&
                action.sms.config === 'body' &&
                action.question !== ''
              "
            >
              10
              <div class="arrow-promoters" />
            </figcaption>
            <figcaption
              class="ballon-text mb-3"
              v-if="
                action.reply.promoters !== null &&
                action.reply.promoters !== '' &&
                action.sms.config === 'body' &&
                action.question !== ''
              "
            >
              {{ action.reply.promoters }}
              <div class="arrow" />
            </figcaption>
            <figcaption
              class="ballon-promoter-answer mb-3"
              v-if="
                switchReply.neutral === true &&
                action.sms.config === 'body' &&
                action.question !== ''
              "
            >
              8
              <div class="arrow-promoters" />
            </figcaption>
            <figcaption
              class="ballon-text mb-3"
              v-if="
                action.reply.neutral !== null &&
                action.reply.neutral !== '' &&
                action.sms.config === 'body' &&
                action.question !== ''
              "
            >
              {{ action.reply.neutral }}
              <div class="arrow" />
            </figcaption>
            <figcaption
              class="ballon-promoter-answer mb-3"
              v-if="
                switchReply.detractors === true &&
                action.sms.config === 'body' &&
                action.question !== ''
              "
            >
              5
              <div class="arrow-promoters" />
            </figcaption>
            <figcaption
              class="ballon-text mb-3"
              v-if="
                action.reply.detractors !== null &&
                action.reply.detractors !== '' &&
                action.sms.config === 'body' &&
                action.question !== ''
              "
            >
              {{ action.reply.detractors }}
              <div class="arrow" />
            </figcaption>
          </div>
        </picture>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'TemplateSms',
  computed: {
    ...mapState('actions', ['action']),
    ...mapState('settings', ['switchReply']),
    msgLinkInput() {
      return document.getElementById('message-link-id');
    },
  },
  watch: {
    'action.sms.msgLink': function watchMsgLink(value) {
      if (value === '') {
        this.msgLinkInput.classList.add('is-invalid');
      } else {
        this.msgLinkInput.classList.remove('is-invalid');
      }

      if (value.length > 129) {
        this.smsError = this.$t('newAction.stepOne.messageError.errorExceed');
      } else {
        this.smsError = null;
      }
    },
  },

  data: () => ({
    smsError: null,
  }),
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

picture {
  position: relative;
}

.sms-card {
  padding: 10px 15px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.msgs-area {
  padding: 10px 0;
  overflow-y: auto;
  position: absolute;
  top: 50px;
  left: 30px;
  max-height: 430px;
}

.ballon-text {
  background-color: $primary;
  color: $white;
  width: 185px;
  border-radius: 6px;
  padding: 5px 10px;
  box-sizing: border-box;
  word-wrap: break-word;
}
.arrow {
  position: absolute;
  right: 10px;
  height: 0;
  border-top: 12px solid $primary;
  border-left: 12px solid transparent;
}

.ballon-promoter-answer {
  background-color: $info;
  color: $white;
  max-width: 40px;
  border-radius: 6px;
  padding: 5px;
  box-sizing: border-box;
  word-wrap: break-word;
  text-align: center;

  .arrow-promoters {
    position: absolute;
    left: 10px;
    width: 0;
    border-top: 12px solid $info;
    border-right: 12px solid transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/action-templates/sms/index.vue